<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-4 p-0">
          <div class="card-group mb-4">
            <div class="card p-4 login-left">
              <div class="card-body">
                &nbsp;
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-5 p-0">
          <div class="card-group mb-4">
            <div class="card p-4 login-right">
              <div class="card-body">
                <div class="detailed">
                  <h1 class="">{{$t('WELCOMEBACK')}}</h1>
                  <!--<p class="text-muted">{{$t('WELCOMETAGLINE')}}</p>-->
                </div>
                <h1>{{$t('LOGINTOACCOUNT')}}</h1>
                <p class="text-muted">{{$t('ENTERYOURPASSWORDUSER')}}</p>
                <div class="form-group mb-3">
                  <label class="custom-label">{{$t('USERNAME')}}</label>
                  <input type="text" v-model="username" v-on:keyup.13="login" class="form-control" v-bind:placeholder="$t('USERNAME')">
                </div>
                <div class="form-group mb-4">
                  <label class="custom-label">{{$t('PASSWORD')}}</label>
                  <input type="password" v-model="password" v-on:keyup.13="login" class="form-control custom-input" v-bind:placeholder="$t('PASSWORD')">
                </div>
                <div class="row">
                  <div class="col-12">
                    <p class="bg-danger" v-if="loginResponse.error && loginResponse.notice">{{loginResponse.notice}}</p>
                  </div>
                  <div class="col-12">
                    <button type="button" v-on:click.prevent="login" class="btn button-save">{{$t('LOGIN')}}</button>
                  </div>
                  <!-- div class="col-6 text-right">
                    <button type="button" class="btn btn-link px-0">{{$t('FORGOTPASSWORD')}}</button>
                  </!-->
                </div>
              </div>
            </div>
            <!-- div class="card text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <div class="card-body text-center">
                <div>
                  <h2>{{$t('SIGNUP')}}</h2>
                  <p>{{$t('SIGNUPINTRO')}}</p>
                  <button type="button" class="btn btn-primary active mt-3">{{$t('REGISTERNOW')}}</button>
                </div>
              </div>
            </!-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Login',
  data: function()
  {
    return {username: '', password: ''}
  },
  methods:
  {
    ...mapActions({
      actLogin: 'login'
    }),
    login: function(bvEvt)
    {
      bvEvt.preventDefault();
      this.actLogin({username: this.username, password: this.password});
    }
  },
  computed:
  {
    ...mapGetters([
      'loginResponse'
    ])
  }
}
</script>
